import React from 'react'
import { cn } from '@/utils/index'

type FieldMessageProps = {
  message: string | null
}

/** Error line under a field; keeps its height (invisible placeholder) when there is no message. */
export const FieldMessage: React.FC<FieldMessageProps> = ({ message }) => {
  return (
    <p
      className={cn('min-h-5 text-sm leading-5', message ? 'text-destructive' : 'invisible')}
      aria-hidden={message ? undefined : true}
    >
      {message ?? '.'}
    </p>
  )
}
